import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { AlumnoService } from '../../../../services/alumno.service';
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { Subscription, Subject } from 'rxjs';
import { take, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { AlumnoList } from '../../../../interfaces/alumno.interface';
import { GradoService } from 'src/app/services/grado.service';

@Component({
	selector: 'app-alumnos-list',
	templateUrl: './alumnos-list.component.html',
	styleUrls: ['alumnos-list.component.scss']
})
export class AlumnosListComponent implements OnInit, AfterViewInit, OnDestroy {
	displayedColumns = ['nombre', 'apellido', 'legajo', 'grado'];
	dataSource = new MatTableDataSource<any>();
	
	@ViewChild(MatPaginator) paginator!: MatPaginator;
	@ViewChild(MatSort) sort!: MatSort;
	
	length = 0;
	pageIndex = 0;
	gradoId = 0;
	grados = [];
	stringFilter = '';
	inactivos = false;

	private searchSubject = new Subject<void>();
	private destroy$ = new Subject<void>();
	private searchSubscription?: Subscription;

	constructor(private alumnoService: AlumnoService, private gradosService: GradoService) { }

	ngOnInit() {
		// Inicialización reactiva con debounce de búsqueda
		this.searchSubject.pipe(
			debounceTime(300),
			takeUntil(this.destroy$)
		).subscribe(() => {
			this.applyFilter();
		});

		// Carga inicial
		this.getData(this.pageIndex, 10, '');

		// Carga de grados
		this.gradosService.getGradosPorEscuelaNoPaging()
			.pipe(take(1))
			.subscribe(c => this.grados = c.resultList);
	}

	ngAfterViewInit() {
		this.dataSource.sort = this.sort;
	}

	doFilter() {
		this.pageIndex = 0;
		if (this.paginator) {
			this.paginator.pageIndex = this.pageIndex;
		}
		// Disparar la búsqueda reactivamente
		this.searchSubject.next();
	}

	clearFilters() {
		this.stringFilter = '';
		this.gradoId = 0;
		this.inactivos = false;
		this.doFilter();
	}

	private applyFilter() {
		if (this.stringFilter && this.stringFilter.length > 2) {
			const cleanFilter = this.stringFilter.toLowerCase();
			this.getData(this.pageIndex, 10, cleanFilter);
		} else {
			this.getData(this.pageIndex, 10, '');
		}
	}

	getData(pageIndex: number, pageSize: number, filter: string) {
		const dataFilter = { filterLike: filter, gradoId: this.gradoId, inactivos: this.inactivos };
		
		// Cancelar la suscripción anterior para evitar fugas de memoria y race conditions
		if (this.searchSubscription) {
			this.searchSubscription.unsubscribe();
		}

		this.searchSubscription = this.alumnoService.getAlumnosPorEscuelaYFiltros(pageIndex, pageSize, dataFilter)
			.subscribe((fs: AlumnoList) => {
				this.dataSource.data = fs.resultList;
				this.length = fs.total;
				if (this.paginator) {
					this.paginator.length = this.length;
				}
			});
	}

	public getServerData(event?: PageEvent) {
		if (event) {
			this.pageIndex = event.pageIndex;
			const currentFilter = (this.stringFilter && this.stringFilter.length > 2) 
				? this.stringFilter.toLowerCase() 
				: '';
			this.getData(event.pageIndex, event.pageSize, currentFilter);
		}
		return event;
	}

	ngOnDestroy() {
		if (this.searchSubscription) {
			this.searchSubscription.unsubscribe();
		}
		this.destroy$.next();
		this.destroy$.complete();
	}
}
